import { render, staticRenderFns } from "./chakang.vue?vue&type=template&id=f27a4b20&scoped=true&"
import script from "./chakang.vue?vue&type=script&lang=js&"
export * from "./chakang.vue?vue&type=script&lang=js&"
import style0 from "./chakang.vue?vue&type=style&index=0&id=f27a4b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27a4b20",
  null
  
)

export default component.exports